<template>
  <div class="step">
    <div class="step__section">
      <div class="step__header">
        <div class="step__header__title">
          {{ asideData.stepData.step1.name }}
        </div>
        <div
          class="step__header__icon"
          :style="{
            '--bg': asideData.stepData.step1.niche.background
          }"
        >
          <img :src="asideData.stepData.step1.niche.icon" alt="Карточка тренера" />
        </div>
      </div>
    </div>
    <div class="step__section">
      <div class="step__card">
        <div class="step__card__title">
          {{
            asideData.stepData.step2.coachList.length > 1
              ? 'Достижения тренеров'
              : 'Достижения тренера'
          }}
        </div>
        <div
          v-for="(coach, coachIndex) in asideData.stepData.step2.coachList"
          :key="coachIndex"
          class="step__card__coach-section"
        >
          <div class="step__card__coach-title">
            {{ coach.name }}
          </div>
          <div class="step__card__list">
            <li v-for="(achievement, index) in coach.achievements" :key="'achievement-' + index">
              {{ achievement }}
            </li>
          </div>
          <div class="step__card__business"><span>Бизнес: </span> {{ coach.businessName }}</div>
        </div>
      </div>
    </div>
    <div class="step__section step__section--video">
      <div class="step__title">Видео-визитка</div>
      <Input
        v-model="youtubeVideoUrl"
        type="text"
        :error="!validations.youtubeVideoUrl.value && youtubeVideoUrlIsDirty"
        :error-message="validations.youtubeVideoUrl.error"
        required
        label="Ссылка на видео-визитку"
        placeholder="Ссылка на youtube видео"
      />
    </div>
    <div class="step__section step__section--content">
      <div class="step__section--images__header">
        <div>
          <div class="step__title">
            О сборной
            <span class="step__title__required">*</span>
          </div>
          <div class="step__description">Добавь описание о сборной</div>
        </div>
      </div>
      <ContentEditor v-model="asideDataClone.stepData.step3.content" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Input from '@/components/UiKit/v2/Input';
import ContentEditor from '@/views/Faculties/admin/components/FacultyAside/components/ContentEditor';

export default {
  components: {
    ContentEditor,
    Input
  },
  props: {
    asideData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      asideDataClone: {},
      youtubeVideoUrl: '',
      youtubeVideoUrlIsDirty: false
    };
  },
  computed: {
    validations() {
      return {
        youtubeVideoUrl: this.validateYoutubeVideoUrl,
        content: this.validateContent
      };
    },
    validateYoutubeVideoUrl() {
      const result = {
        value: true,
        error: ''
      };
      const longYoutubeUrlList = [
        'https://www.youtube.com/',
        'https://youtube.com/',
        'www.youtube.com',
        'youtube.com'
      ];
      const shortYoutubeUrlList = [
        'https://www.youtu.be/',
        'https://youtu.be/',
        'www.youtu.be',
        'youtu.be'
      ];
      const isYoutubeUrlFieldEmpty = this.youtubeVideoUrl === '' && !this.youtubeVideoUrlIsDirty;
      const isShortYoutubeUrlIncludesCorrectDomain = shortYoutubeUrlList.some(urlBase =>
        this.youtubeVideoUrl.startsWith(urlBase)
      );
      const isLongYoutubeUrlIncludesCorrectDomain = longYoutubeUrlList.some(urlBase =>
        this.youtubeVideoUrl.startsWith(urlBase)
      );
      const isYoutubeVideoUrl =
        isLongYoutubeUrlIncludesCorrectDomain || isShortYoutubeUrlIncludesCorrectDomain;
      const isCorrectVideoId = this.youtubeVideoId?.length === 11;

      if (!isYoutubeVideoUrl || !isCorrectVideoId || isYoutubeUrlFieldEmpty) {
        result.value = false;
        result.error = 'Укажите URL адрес на Youtube видео';
      }
      return result;
    },
    youtubeVideoId() {
      const regex = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
      return this.youtubeVideoUrl ? regex.exec(this.youtubeVideoUrl)?.[3] : '';
    },
    validateContent() {
      return {
        value: !!this.asideData.stepData.step3.content,
        error: ''
      };
    },
    stepIsValid() {
      return Object.values(this.validations).every(item => item.value);
    }
  },
  watch: {
    stepIsValid(value) {
      this.asideDataClone.isValid = value;
    },
    youtubeVideoUrl() {
      this.youtubeVideoUrlIsDirty = true;
      this.asideDataClone.stepData.step3.youtubeVideoId = this.youtubeVideoId;
      this.asideDataClone.stepData.step3.youtubeVideoUrl = this.youtubeVideoUrl;
    },
    asideDataClone: {
      deep: true,
      handler(value) {
        this.$nextTick(() => {
          this.$emit('update:asideData', value);
        });
      }
    }
  },
  created() {
    this.asideDataClone = _.cloneDeep(this.asideData);
    this.youtubeVideoUrl = this.asideDataClone.stepData.step3.youtubeVideoUrl;
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.step {
  &__title {
    margin-bottom: 8px !important;

    &__required {
      color: #eb5757;
    }
  }

  &__card {
    &__coach-section {
      margin-bottom: 12px;
    }

    &__list li {
      margin-bottom: 8px;
      line-height: 20px;

      &:last-child {
        margin-bottom: 16px;
      }
    }

    &__coach-title {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 8px;
    }

    &__business {
      color: $ui-black;
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 16px;
      span {
        color: #ababba;
      }
    }
  }

  &__section--content {
    padding-bottom: 20px !important;

    &::v-deep ul,
    &::v-deep ol {
      p,
      h1,
      h3 {
        display: inline;
      }
    }

    &::v-deep ul {
      list-style-type: disc;
      list-style-position: inside;
    }
    &::v-deep ol {
      list-style-type: decimal;
      list-style-position: inside;
    }

    &::v-deep p,
    &::v-deep h1,
    &::v-deep h3 {
      @include uiFont;
      font-weight: 400;
    }

    &::v-deep p {
      font-size: 14px;
      margin-bottom: 8px;
    }

    &::v-deep li {
      font-size: 14px;
      margin-bottom: 8px;
    }

    &::v-deep h1 {
      font-size: 36px;
      margin-bottom: 18px;
    }

    &::v-deep h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .ui-kit-file {
        display: contents;
      }
    }
  }
}
</style>
